import { NgClass } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { clsx } from 'clsx';

import { IconButtonComponent } from '../../button';
import { IconComponent } from '../../icon';
import { ProgressBarComponent } from '../../progress-bar/progress-bar.component';
import { SbDialogModule } from '../dialog.module';

export enum DialogActivationFlowOrder {
  MAIN_PANEL_FIRST = 'main-panel-first',
  ASIDE_PANEL_FIRST = 'aside-panel-first',
}

@Component({
  selector: 'sb-dialog-activation',
  standalone: true,
  imports: [SbDialogModule, IconButtonComponent, IconComponent, ProgressBarComponent, TranslateModule, NgClass],
  templateUrl: './dialog-activation.component.html',
})
export class DialogActivationComponent {
  @HostBinding('class')
  hostClass = clsx('flex flex-col lg:h-activation-dialog');

  @Input()
  showTitle = false;

  @Input()
  showCloseButton?: boolean;

  @Input()
  showBackButton = false;

  @Input()
  showProgressBar = false;

  @Input()
  asidePanelAlwaysVisible = false;

  @Input()
  currentStep = 0;

  @Input()
  totalSteps = 0;

  @Input()
  hideSidePanel = false;

  /**
   * The flow order for content and aside. Only applies in single column layout.
   *
   * @default DialogActivationFlowOrder.MAIN_PANEL_FIRST
   */
  @Input()
  flowOrder: DialogActivationFlowOrder = DialogActivationFlowOrder.MAIN_PANEL_FIRST;

  @Output()
  back = new EventEmitter<void>();

  public DialogActivationFlowOrder = DialogActivationFlowOrder;
}
